import { render, staticRenderFns } from "./EditAdditionalStep.vue?vue&type=template&id=31c1fe7a&"
import script from "./EditAdditionalStep.vue?vue&type=script&lang=ts&"
export * from "./EditAdditionalStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports